import React from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const SUPPORT_EMAIL = "support@cloudarchive.app";
const SUPPORT_WHATSAPP = "+966 53 646 5410";

const BlockIcon = () => (
  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="4.9" y1="4.9" x2="19.1" y2="19.1" />
  </svg>
);

// Admin ne organization disable ki ho to login par ye modal dikhta hai (API code 403)
const OrganizationDisabledModal = ({ message, ...props }) => {
  const { t,  i18n: { language } } = useTranslation();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Box className="d-flex flex-column align-items-center py-3 px-2 gap-2">
          <BlockIcon />
          <HeadingStyled size="24px" weight="bold" color="var(--text)" className="text-center">
            {t("organization_disabled_title")}
          </HeadingStyled>
          <TextStyled
            size="16px"
            weight="500"
            color="var(--text)"
            className="text-center px-3"
          >
            {language.startsWith("ar")
              ? t("organization_disabled_message", { lng: "ar" })
              : message || t("organization_disabled_message")}
          </TextStyled>
          <Box className="w-100 rounded border px-3 py-2 mt-2">
            <TextStyled size="14px" weight="600" color="var(--text2)" className="mb-1">
              {t("contact_support")}
            </TextStyled>
            <TextStyled size="15px" color="var(--text)" className="mb-1">
              {t("email")}:{" "}
              <a href={`mailto:${SUPPORT_EMAIL}`} dir="ltr" className={language === 'en' ? 'ms-1': 'me-1'}>{SUPPORT_EMAIL}</a>
            </TextStyled>
            <TextStyled size="15px" color="var(--text)">
              {t("whatsapp")}:{" "}
              <a href={`https://wa.me/${SUPPORT_WHATSAPP.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer" dir="ltr" className={language === 'en' ? 'ms-1': 'me-1'}>
                {SUPPORT_WHATSAPP}
              </a>
            </TextStyled>
          </Box>
          <ButtonStyled
            onClick={props.onHide}
            className="w-100"
            clName="w-100 mt-2"
            label={t("ok")}
          />
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default OrganizationDisabledModal;
